var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 104,
    viewBox: "0 0 118 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 34.6C71.0812 34.6 62.5612 34.26 54.5912 32.04C46.7712 29.87 39.5912 25.66 33.1912 20.79C29.0012 17.62 25.1912 15.1 19.7512 15.48C14.4247 15.7716 9.3336 17.7702 5.23121 21.18C-1.68879 27.18 -0.648793 38.41 2.12121 46.3C6.28121 58.18 18.9412 66.41 29.7012 71.79C42.1312 78 55.7912 81.6 69.4812 83.68C81.4812 85.5 96.9012 86.83 107.301 78.99C116.851 71.79 119.471 55.35 117.131 44.25C116.564 40.9679 114.818 38.0058 112.221 35.92C105.511 31.02 95.5012 34.29 87.9612 34.46C85.1612 34.52 82.3112 34.59 79.4512 34.6Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 103.13C79.2456 103.13 95.6812 102.105 95.6812 100.84C95.6812 99.5753 79.2456 98.55 58.9712 98.55C38.6969 98.55 22.2612 99.5753 22.2612 100.84C22.2612 102.105 38.6969 103.13 58.9712 103.13Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5219 4.3019L28.9869 24.7227C27.039 25.4262 26.0303 27.5757 26.7339 29.5236L38.6616 62.5454C39.3652 64.4933 41.5146 65.502 43.4625 64.7984L99.9975 44.3777C101.945 43.6741 102.954 41.5247 102.251 39.5768L90.3229 6.55491C89.6193 4.60702 87.4698 3.59831 85.5219 4.3019Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2012 82.44C42.7424 82.44 43.1812 82.0012 43.1812 81.46C43.1812 80.9187 42.7424 80.48 42.2012 80.48C41.66 80.48 41.2212 80.9187 41.2212 81.46C41.2212 82.0012 41.66 82.44 42.2012 82.44Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2212 1.96C68.7625 1.96 69.2012 1.52124 69.2012 0.98C69.2012 0.43876 68.7625 0 68.2212 0C67.68 0 67.2412 0.43876 67.2412 0.98C67.2412 1.52124 67.68 1.96 68.2212 1.96Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9912 8.28998V12.6",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8313 10.45H43.1413",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.221 24.22V28.52",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.061 26.37H106.371",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6788 26.2538L28.2353 35.1801C26.1872 35.4876 24.7762 37.3973 25.0837 39.4454L30.2976 74.1661C30.6051 76.2142 32.5148 77.6252 34.5629 77.3177L94.0064 68.3913C96.0545 68.0838 97.4655 66.1741 97.1579 64.126L91.9441 29.4053C91.6365 27.3572 89.7269 25.9462 87.6788 26.2538Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1502 31.7647L79.1463 32.5161C78.3107 32.6416 77.735 33.4207 77.8605 34.2564L78.6119 39.2603C78.7374 40.0959 79.5165 40.6716 80.3522 40.5461L85.356 39.7947C86.1917 39.6692 86.7674 38.8901 86.6419 38.0544L85.8905 33.0505C85.765 32.2149 84.9859 31.6392 84.1502 31.7647Z",
    fill: "#D2D2D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4433 61.7577L35.8173 63.9541C35.3585 64.0229 35.0424 64.4507 35.1113 64.9095L35.1767 65.3446C35.2455 65.8034 35.6733 66.1194 36.1321 66.0505L50.7581 63.8542C51.2169 63.7853 51.5329 63.3576 51.464 62.8988L51.3987 62.4637C51.3298 62.0049 50.902 61.6889 50.4433 61.7577Z",
    fill: "#D2D2D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3313 64.5629L36.6667 68.1165C36.0877 68.2035 35.6889 68.7433 35.7758 69.3222C35.8628 69.9011 36.4025 70.3 36.9815 70.213L60.6461 66.6594C61.2251 66.5725 61.6239 66.0327 61.537 65.4538C61.45 64.8748 60.9103 64.476 60.3313 64.5629Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateUsers);
export default __webpack_public_path__ + "static/media/empty-state-users.fad53767d9c93b1f56d79ca8ff1d39a7.svg";
export { ForwardRef as ReactComponent };